module.exports = __webpack_public_path__ + "static/media/shopping_list_coming_soon.03e1e904.png";